/** Leave types whose automatic ordinary-hours and public-holiday rule is source-proven. */
export const LEAVE_AUTOMATIC_HOURS_POLICY_TYPES = ['ANNUAL', 'PERSONAL'] as const;

const LEAVE_AUTOMATIC_HOURS_POLICY_TYPE_SET: ReadonlySet<string> = new Set(
  LEAVE_AUTOMATIC_HOURS_POLICY_TYPES,
);

export function isLeaveAutomaticHoursPolicyType(value: unknown): boolean {
  return typeof value === 'string' && LEAVE_AUTOMATIC_HOURS_POLICY_TYPE_SET.has(value);
}

export const LEAVE_AUTOMATIC_HOURS_POLICY_HOLD_HELPER =
  'Other full-day leave types do not have verified automatic hours. Ask a coordinator to enter reviewed hours one day at a time; split a multi-day request into daily requests.';
